import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles(({ palette }) => ({
  root: {
    color: grey[600],
  },
  itemContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  label: {
    width: "100%",
    fontSize: 14,
    color: grey[600],
    "&.Mui-disabled": {
      color: palette.disabledText.main,
    },
  },
  controlLabelRoot: {
    width: "100%",
  },
  checked: {
    "& + .MuiFormControlLabel-label": {
      color: "black",
      fontWeight: 500,
    },
  },
  list: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
}));

export default useStyles;
